import logger from 'redux-logger'
import { isAction, type Middleware } from '@reduxjs/toolkit'
import {
  recordReduxAction,
  setReduxTelemetryStateGetter,
} from './telemetryContext'

let reduxTelemetryGetterRegistered = false

const telemetryReduxMiddleware: Middleware = storeApi => next => action => {
  if (!reduxTelemetryGetterRegistered) {
    setReduxTelemetryStateGetter(() => storeApi.getState())
    reduxTelemetryGetterRegistered = true
  }

  if (isAction(action)) {
    recordReduxAction(action)
  }

  return next(action)
}

export const getMiddlewares = () => {
  if (['production', 'test'].includes(process.env.NODE_ENV || '')) {
    return [telemetryReduxMiddleware]
  }

  return [telemetryReduxMiddleware, logger]
}
